import parse from "date-fns/parseISO";
import { Column, Cell } from "react-table";

import nameof from "../../../common/helpers/nameof";
import TextFilter from "../../../common/components/ReactTable/Components/Filtering/TextFilter";
import { shortDate } from "../../../common/helpers/date";

import { MarketingActivity as Activity } from "../../../api";

const columns: Column<Activity>[] = [{
  Header: "Name",
  Footer: "Name",
  accessor: nameof<Activity>("name"),
  Filter: TextFilter,
}, {
  Header: "Objectives",
  Footer: "Objectives",
  accessor: nameof<Activity>("objectiveIds"),
  Cell: ({ value }: Cell<Activity, string[] | undefined>) => {
    return !!value?.length ? value.length : "";
  },
  disableSortBy: true,
}, {
  Header: "Publication Live",
  Footer: "Publication Live",
  accessor: nameof<Activity>("publicationDate"),
  Cell: ({ value }: Cell<Activity, string | undefined>) => {
    return value ? shortDate(parse(value)) : "";
  },
}, {
  Header: "Content Deadline",
  Footer: "Content Deadline",
  accessor: nameof<Activity>("deadlineDate"),
  Cell: ({ value }: Cell<Activity, string | undefined>) => {
    return value ? shortDate(parse(value)) : "";
  },
}, {
  Header: "Completed",
  Footer: "Completed",
  accessor: nameof<Activity>("completedDate"),
  Cell: ({ value }: Cell<Activity, string | undefined>) => {
    return value ? shortDate(parse(value)) : "";
  },
}, {
  Header: "Status",
  Footer: "Status",
  accessor: nameof<Activity>("status"),
}];

export default columns;
